const route = {
    path: '/apps',
    children: [
        {
            path: '',
            components: {
                default:
                    () => import(/* webpackChunkName: "apps" */ '../../components/views/apps.vue'),
            }
        },
    ],
}

module.exports = route;